/* eslint-disable @typescript-eslint/no-namespace */
export enum Pages {
  baseUrl = '/',
  results = '/results',
  result = '/results/:id',
  users = '/users',
  user = '/users/:id',
  home = '/home',
  organizations = '/organizations',
  createOrganization = '/organizations/create',
  editOrganization = '/organizations/:id',
  AIplayground = '/ai-playground',
  FeeSchedules = '/fee-schedules',
}

export namespace Pages {
  export function getRoute(route: Pages, id?: number | string): string {
    let _id = ':id';
    if (id) {
      _id = typeof id === 'number' ? id.toString() ?? '-1' : (id as string);
    }
    switch (route) {
      case Pages.baseUrl:
        return `${Pages.baseUrl}`;
      case Pages.results:
        return `${Pages.results}`;
      case Pages.result:
        return Pages.result.replace(':id', _id);
      case Pages.users:
        return `${Pages.users}`;
      case Pages.user:
        return Pages.user.replace(':id', _id);
      case Pages.home:
        return `${Pages.home}`;
      case Pages.organizations:
        return `${Pages.organizations}`;
      case Pages.editOrganization:
        return Pages.editOrganization.replace(':id', _id);
      case Pages.createOrganization:
        return `${Pages.createOrganization}`;
    }
    return '';
  }
}
